import { ResolveFn } from "@angular/router";
import { inject } from "@angular/core";
import { User } from "../models/user";
// import { CacheService } from '../services/cache.service';
import { AuthService } from "../services/auth.service";
import { tap } from "rxjs";

export const userResolver: ResolveFn<User> = () => {  
    const authService = inject(AuthService);  
    // const cacheService = inject(CacheService);

    return authService.getCurrentUser()
        .pipe(
            tap({
                next: () => {
                    // cacheService.load();
                },
                error: (error) => {
                    console.log(error);
                    // localStorage.removeItem(environment.accessTokenName);
                    // router.navigate(['/login']);
                }
            })
        );
};